import { isNil, isEmptyString, isEmptyObject, isString, isObject } from "../../validate"

export default ({ value }) => {
  if (isNil(value)) return false
  if (isString(value) && isEmptyString(value)) return false
  if (isObject(value) && isEmptyObject(value)) return false
  return true
}
